import { render } from "./Key9.vue?vue&type=template&id=3814cae0"
import script from "./Key9.vue?vue&type=script&lang=ts"
export * from "./Key9.vue?vue&type=script&lang=ts"
script.render = render

export default script